import { Entity } from "./entity.model";
import { HorizonsTeam } from "./horizons-team.model"
import { Profile } from "./profile.model"
import { Role } from "./role.model"
import { Team } from "./team.model"

export class User {
  id!: number;
  entityId!: number;
  entity!: Entity;
  childEntities?: Entity[];
  roleId!: number;
  role?: Role;
  profileId!: number;
  profile!: Profile;
  teamId!: number;
  team?: Team;
  teams?: Team[];
  teamIds?: number[];
  horizonsTeamId!: number;
  horizonsTeam?: HorizonsTeam;
  fullname!: string;
  username!: string;
  email!: string;
  createdAt!: string;
  updatedAt!: string;
  deletedAt!: null;
  calculatedTeamName?: string | null;
}
